import { render, staticRenderFns } from "./TiendaSelectComponent.vue?vue&type=template&id=48b9696a&"
import script from "./TiendaSelectComponent.vue?vue&type=script&lang=js&"
export * from "./TiendaSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./TiendaSelectComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports